import { createSelector } from "reselect"
import { chain } from "lodash"
import { getIndices } from "selectors/indices"
import { getBaskets } from "resources/baskets"

const getPortfolios = state => state.global.data.portfolios.data
const getWatchlists = state => state.global.data.watchlists.data.watchlists
const getEtfs = state => state.global.data.etfs.data
export const getUniverses = state => state.modules.securitiesFinder.universes

export const getPortfoliosList = createSelector(
  [getPortfolios],
  (portfolios) => chain(portfolios)
    .map(({ name: label, id, shortId }) => ({ label, value: shortId || id, type: "portfolio" }))
    .sortBy("label")
    .value(),
)

export const getSwapsList = createSelector(
  [getBaskets],
  (baskets) => chain(baskets)
    .map(({ ticker }) => ({ label: ticker, value: ticker, type: "swap" }))
    .sortBy("label")
    .value(),
)

export const getWatchlistsList = createSelector(
  [getWatchlists],
  (watchlists) => chain(watchlists)
    .map(({ name: label, id, alias }) => ({ label, value: alias || id, type: "watchlist" }))
    .sortBy("label")
    .value(),
)

export const getEtfsList = createSelector(
  [getEtfs],
  (etfs) => chain(etfs)
    .orderBy(["adv"], ["desc"])
    .map(({ ticker, mic, description }) => ({ label: description, value: `${ticker}.${mic}`, ticker, mic, type: "etf" }))
    .value(),
)

export const getIndexesList = createSelector(
  [getIndices],
  (indexes) => chain(indexes)
    .map(({ id, name }) => ({ label: name, value: id, type: "index" }))
    .sortBy("label")
    .value(),
)
